import React, { Fragment, useState, useEffect } from 'react'
import { Col, Container, Row, Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import SurveyPatientForm from './components/PublicForm/SurveyPatientForm';
import SurveysAdministrativeShow from './components/Administrative/SurveysAdministrativeShow';

const SurveyPatients = () => {

    const [activeTab, setActiveTab] = useState('1');
    const [userPermits, setUserPermits] = useState([]);

    useEffect(() => {
        let user = JSON.parse(sessionStorage.getItem('usuario'));

        if (user != null) {
            if (user.perfil != undefined) {
                let perfil = user.perfil.modulos;
                setUserPermits(perfil);
            } else {
                let perfil = [];
                setUserPermits(perfil);
            }
        } else {
        }
    }, [])

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 15 }}>Encuesta a los Pacientes</h3>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        <div className="tabs tabs--justify tabs--bordered-top">
                            <div className="tabs__wrap">
                                <Nav tabs>

                                    {
                                        userPermits.includes(49) ? <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '1' })}
                                                onClick={() => toggle('1')}
                                            >
                                                Encuesta
                                            </NavLink>
                                        </NavItem> : null
                                    }

                                    {
                                        userPermits.includes(50) ? <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '2' })}
                                                onClick={() => toggle('2')}
                                            >
                                                Administrativo
                                            </NavLink>
                                        </NavItem> : null
                                    }

                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        {userPermits.includes(49) ? <SurveyPatientForm surveyExistData={null} /> : null}
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {userPermits.includes(50) ? <SurveysAdministrativeShow /> : null}
                                    </TabPane>
                                </TabContent>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default SurveyPatients